import React from 'react';

function RotatingLoader({ dark, text, background, colour }) {
  return (
    <div className="theFiexedWidth" style={background ? { background } : {}}>
      <div className="loader-container">
        <div className="textUnder">
          <div className="rotatingloader" />
          <p className="loaderText" style={colour ? { color: colour } : {}}>{text}</p>
        </div>
      </div>
    </div>
  );
}

export default RotatingLoader;
